import { render, staticRenderFns } from "./ExcLabeledValue.vue?vue&type=template&id=4cc580d4&scoped=true&"
import script from "./ExcLabeledValue.vue?vue&type=script&lang=ts&"
export * from "./ExcLabeledValue.vue?vue&type=script&lang=ts&"
import style0 from "./ExcLabeledValue.vue?vue&type=style&index=0&id=4cc580d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc580d4",
  null
  
)

export default component.exports